export default __webpack_public_path__ + "static/media/location.0c0840fc.svg";